<!-- 检验检查 -->
<template>
    <div class="app-container">
        <el-container class="container" direction="vertical">
            <el-row>
                <el-row>
                    <div style="font-size: 32;font-weight: bolder;">检验检查</div>
                </el-row>
                <el-row style="background-color: #d5d5d5;height: 0.5px;width: 100%;margin-top: 20px;" />
            </el-row>

            <el-row style="margin-top: 30px;">
                <el-tabs type="border-card" @tab-click="clickTab">
                    <el-tab-pane label="检查">
                        <component :is="currentView2" v-if="update" :pInfo="this.pInfo"></component>
                    </el-tab-pane>
                    <el-tab-pane label="检验">
                        <component :is="currentView1" v-if="update" :pInfo="this.pInfo"></component>
                    </el-tab-pane>
                </el-tabs>
            </el-row>
        </el-container>
    </div>
</template>

<script>
import labInfo from "./labAndExam/labInfo.vue";
import examInfo from "./labAndExam/examInfo.vue";

export default {
    components: { labInfo, examInfo },
    props: {
        pInfo: null
    },
    data() {
        return {
            currentView1: "labInfo",
            currentView2: "examInfo",
            update: true
        };
    },
    created() {
        console.log("pInfo");
        console.log(this.pInfo);
    },
    methods: {
        clickTab(targetName) {
            console.log(targetName);
        }
    }
};
</script>

<style></style>